<template>
    <div v-if="mode == 'form'" class="tag-item" :class="{'isForm': mode == 'form'}">
        <i class="jicon icon-zuzhixinxi" style="color: #00b899;font-size: 11px;margin-right: 4px;"></i>
        {{name}}
        <div class="btn remove-btn" v-if="canRemove" @click.stop="$emit('remove', value)">
            <i class="el-icon-error"></i>
        </div>
    </div>
    <div v-else>
        <span v-if="disabled && printMode" class='showText'>{{name}}</span>
        <el-input v-else :size="size" :value="name" readonly="readonly" suffix-icon="fa fa-sitemap" ></el-input>    
    </div>
    
</template>
<script>
export default {
    name:'l-department',
    props: {
        value:String,
        size:{
            default:'mini'
        },
        mode: {
            default: ''
        },
        canRemove: {
            default: false
        },
        printMode: {
            default: false
        },
        disabled: {
            default: false
        },
    },
    watch: {
        value:{
            handler(newVal){
                if(!this.$validatenull(newVal)){
                    this.lr_loadDepartment && this.lr_loadDepartment(newVal)
                }

                if(this.$validatenull(newVal) && this.loginInfo && this.loginInfo.f_DepartmentId){
                    this.lr_loadDepartment && this.lr_loadDepartment(this.loginInfo.f_DepartmentId)
                    this.$emit('input',this.loginInfo.f_DepartmentId)
                }
            },
            immediate: true
        }
    },
    computed:{
        name(){
            if(this.$validatenull(this.value)){
                return ''
            }
            if(this.lr_department){
                return (this.lr_department[this.value] || {}).f_FullName || ''
            }
            else{
                return ''
            }
        },
    }
}
</script>
<style scoped lang="less">
.tag-item {
        display: inline-flex;
        position: relative;
        align-items: center;
        height: 24px;
        box-sizing: border-box;
        border-radius: 14px;
        overflow: hidden;
        margin-right: 4px;
        width: auto;
        vertical-align: middle;
        overflow: visible;
        &:hover {
            .remove-btn {
                display: inline-block;
            }
        }
        &.isForm {
            background: #f5f7f9;
            height: 28px !important;
            padding: 0 12px;
            margin: 4px 0;
            margin-right: 8px;
            // color: #333;
        }
    }
    .remove-btn {
        display: none;
        position: absolute;
        top: -20px;
        right: -13px;
        font-size: 16px;
        &:hover {
            color: #F56C6C;
        }
    }
</style>